<div class="toast-container" aria-live="polite">
  <div
    *ngFor="let toast of toastService.toasts"
    class="animate__animated animate__fadeIn toast toast--{{ toast.type }} {{ toast.classname }}"
    [attr.role]="toast.type === 'error' ? 'alert' : 'status'"
    data-testid="toast"
  >
    <i class="fa toast__icon" [ngClass]="toast.icon" aria-hidden="true"></i>
    <div class="toast__text" [innerHTML]="toast.text"></div>
    <button type="button" class="toast__close" aria-label="Fechar aviso" (click)="toastService.remove(toast)" data-testid="toast-close">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
</div>
